module.exports = __webpack_public_path__ + "static/media/Gor 2018.11.03-1psd.36a7e2da.jpg";